module.exports = __webpack_public_path__ + "static/fonts/iconfont.5a128744.woff";